<script>
  export let text = "";
  export let iconComponent = null;
  export let iconClass = "";
  export let iconLeft = false;
  export let iconRight = false;
  /** @type {"primary" | "secondary" | "tertiary" | "outline" | "ghost" | "paxAI"} */
  export let variant = "primary";
  export let disabled = false;
  export let selection = false;
  export let icon = "arrow_right";
  export let rounded = false;
  export let smallRounded = false;
  export let notAllowed = false;
  /** @type {"sm" | "md" | "lg"} */
  export let size = "md";
  export let width = "fit-content";
  $$restProps;
</script>

<button
  type="button"
  disabled={disabled || notAllowed}
  class={`button-${variant} ${disabled ? "button-disable" : ""} ${rounded ? "rounded" : ""} ${smallRounded ? "small-rounded" : ""} ${notAllowed ? "not_allowed" : ""} button-${size}`}
  style="width: {width};"
  on:click
  >{#if iconComponent}
    <svelte:component this={iconComponent} class={iconClass} />
  {/if}
  {#if iconLeft === true}
    <div class="icon">
      <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
    </div>
  {/if}
  <span>
    {text}
  </span>
  {#if iconRight}
    <div class="icon">
      <img src="/img/assistant/icons/{icon}.svg" alt={icon} />
    </div>
  {/if}
  {#if selection}
    <select name="cars" id="cars">
      <option value="newVersion">new version</option>
      <option value="newProcess ">new process </option>
    </select>
  {/if}
</button>

<style>
  button {
    border-radius: 0.5rem;
    color: var(--pax-white);
    font-size: 1rem;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    white-space: nowrap;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: center;
    height: 3rem;
    transition: 100ms ease-in-out;
  }

  button:not(.not_allowed):hover {
    cursor: pointer;
  }

  .button-secondary:not(.not_allowed):hover,
  .button-tertiary:not(.not_allowed):hover {
    background-color: #2a2a2f;
  }

  .button-outline:not(.not_allowed):hover {
    background-color: var(--pax-smoke, #f7f8fa) !important;
  }

  .button-ghost:not(.not_allowed):hover {
    background-color: rgba(0, 0, 0, 0.08);
  }

  .button-paxAI:not(.not_allowed):hover {
    background-color: rgba(255, 255, 255, 0.16);
  }

  .button-md {
    height: 3rem;
  }

  .button-sm {
    height: 2.5rem;
  }

  :global(.button-primary) {
    background: var(--pax-orange);
  }

  :global(.button-secondary) {
    background: var(--pax-black);
  }
  :global(.button-tertiary) {
    background: var(--pax-black);
  }

  :global(.button-outline) {
    background: var(--pax-white, #ffffff) !important;
    color: var(--pax-black, #1e293b) !important;
    border: 1px solid var(--pax-border-color, #e2e8f0) !important;
    font-weight: 600 !important;
  }

  :global(.button-ghost) {
    background: transparent !important;
    color: var(--pax-black) !important;
    border: 1px solid var(--pax-black) !important;
  }

  :global(.button-paxAI) {
    background: transparent;
    color: var(--pax-white) !important;
    border: 1px solid var(--pax-white);
  }

  :global(.button-disable) {
    opacity: 0.5 !important;
  }

  .rounded {
    border-radius: 1rem;
    height: 2rem;
  }
  .bx--label {
    display: none !important;
  }

  .bx--select-input {
    border: 1px solid red !important;
  }

  select {
    outline: none;
    background-color: transparent;
    color: white;
    border: none !important;
  }

  option {
    color: black !important;
  }

  .small-rounded {
    border-radius: 1rem;
    height: 1.75rem;
  }

  .small-rounded .icon img {
    width: 0.75rem;
    height: 0.75rem;
  }

  .not_allowed {
    opacity: 50%;
    background-color: var(--pax-black);
    color: var(--pax-white);
    cursor: not-allowed;
  }

  .not_allowed:hover {
    opacity: 50%;
    background-color: var(--pax-black);
    color: var(--pax-white);
    cursor: not-allowed;
  }

  /* .button-disable.not_allowed {
    opacity: 50%;
    cursor: not-allowed;
  } */

  .button-disable.not_allowed:hover {
    opacity: 50%;
    cursor: not-allowed;
  }

  .button-primary.button-disable.not_allowed {
    background-color: var(--pax-orange);
  }

  .button-secondary.button-disable.not_allowed {
    background-color: var(--pax-black);
  }

  .button-tertiary.button-disable.not_allowed {
    background-color: var(--pax-black);
  }
</style>
